import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import useUser from '@hooks/auth/useUser';
import ArrowLineRight from '@icons/arrow/ArrowLineRight';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

function UserInfo() {
    const { t } = useTranslation('main', { keyPrefix: 'sidebar' });
    const { user } = useUser();

    if (user) {
        return (
            <Text fontWeight='bold' size='3xl' css={css`
                    white-space: wrap;
                    word-break: break-all;
                `}>
                {t('userName', {
                    name: user?.nickname
                        || user?.identityInfo?.name
                        || t('defaultName'),
                })}
            </Text>
        );
    }
    return (<Link activityName='SignInActivity'
        activityParams={{}}>
        <Row>
            <Text size='3xl' fontWeight='bold'>{t('login')}</Text>
            <ArrowLineRight size={24} color={colors.gray6}/>
        </Row>
    </Link>);
}

export default UserInfo;
